import { Typography } from '@kizen/kds/Typography';
import { formatBillingCurrency } from '../../util';

type AmountRowProps = {
  label: string;
  amount: number;
  currencySymbol?: string;
  qaId?: string;
};

export const AmountRow = ({
  label,
  amount,
  currencySymbol,
  qaId,
}: AmountRowProps) => {
  return (
    <div className="flex justify-between gap-x-10" data-qa-id={qaId}>
      <Typography size="md">{label}</Typography>
      <Typography size="md" className="whitespace-nowrap">
        {formatBillingCurrency(amount, true, currencySymbol)}
      </Typography>
    </div>
  );
};
